import {
    FETCH_CASH_COLLECTION_ORDER,
    RESET_CASH_COLLECTION_ORDER,
  } from "../../constants/action.constants";
  
  import { getAccessToken } from "../../services/browserStorage";
  import { webApiCheck } from "../../services/commonMethods";
  import { postDashboardWebApi } from "../../webApis/apiResource";
  
  export const requestCashCollection = (urlEndPoint, payload) => {
    return async (dispatch) => {
      const response = await postDashboardWebApi(
        getAccessToken(),
        urlEndPoint,
        payload
      );
      if (webApiCheck(response)) {
        dispatch(fetchCashCollection(response.data));
      }
    };
  };
  
  const fetchCashCollection = (resp) => {
    const { data, ...others } = resp;
    return {
      type: FETCH_CASH_COLLECTION_ORDER,
      payload: data,
      others,
    };
  };
  
  export const resetCashCollection = () => {
    return {
      type: RESET_CASH_COLLECTION_ORDER,
    };
  };
  